var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteMetro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lx8h9r7p7a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.431372 0 0 0 0 0.384314 0 0 0 0 0.349020 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.89 7.313c0-.42-.341-.762-.761-.762H7.87c-.42 0-.762.342-.762.761v8.024h11.782V7.312zm-2.945 2.285h-5.89V8.074h5.89v1.524z",
    transform: "translate(1.000000, 1.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.192 3.808C19.737 1.352 16.472 0 13 0 9.528 0 6.263 1.352 3.808 3.808 1.352 6.263 0 9.528 0 13v13h7.16v-3.047H5.586V7.313c0-1.26 1.025-2.286 2.285-2.286H18.13c1.26 0 2.285 1.025 2.285 2.285v15.641H18.84V26H26V13c0-3.472-1.352-6.737-3.808-9.192z",
    transform: "translate(1.000000, 1.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11 21.43h11.78v-4.57H7.11v4.57zm9.445-3.047c.42 0 .761.34.761.762 0 .42-.34.761-.761.761s-.762-.34-.762-.761.341-.762.762-.762zm-7.11 0c.421 0 .762.34.762.762 0 .42-.341.761-.762.761-.42 0-.761-.34-.761-.761s.34-.762.761-.762zM8.684 22.953L17.316 22.953 17.316 26 8.684 26z",
    transform: "translate(1.000000, 1.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteMetro);
export default __webpack_public_path__ + "static/media/transporte-metro.64dc94ad.svg";
export { ForwardRef as ReactComponent };